import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Закрыть заказ',
      title: 'Закрыть заказ',
      executeAction: 'Закрыть',
      errorMessage: 'Ошибка',
      successMessage: 'Заказ успешно закрыт',
    }
  }
}